<template>
    <div class="widget-calendar">
        <dashboardCard heading='CPU Usage' :data1="systemCpuCount" :data2="processUpTime" :data3="cpuStartTime">
        </dashboardCard>
    </div>
</template>
<script>
import dashboardCard from "./CardData.vue";
export default {
    name: "cpuUsageDetail",
    components: {
        dashboardCard
    },
    data() {
        return {
            systemCpuCount: {},
            processUpTime: {},
            cpuStartTime: {},
        };
    },
    methods: {
        getProcessStartTime(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    const timestampInMilliseconds = parseFloat(response.server.data[0].value) * 1000;
                    this.cpuStartTime.value = this.formatTimeFromEpoch(timestampInMilliseconds);
                    this.cpuStartTime.name = 'Cpu Start Time';
                    this.cpuStartTime.description = 'Shows the exact time when the process started.';
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getSytemCpuCount(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.systemCpuCount.value = this.formatValue(response.server.data[0].value);
                    this.systemCpuCount.name = 'System Cpu Count';;
                    this.systemCpuCount.description = 'Represents the number of CPU cores available to the process.';
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getProcessUpTime(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    let seconds = response.server.data[0].value.toFixed(0);
                    this.processUpTime.value = this.formatTime(seconds);
                    this.processUpTime.name = 'Process Up Time';
                    this.processUpTime.description = 'Measures how long the application has been running.';
                })
                .catch(error => {
                    console.log(error);
                });
        },
        formatValue(value) {
            if (value >= 100 && value < 100000) {
                return (value / 1000).toFixed(2) + 'k';
            } else if (value >= 100000 && value < 10000000) {
                return (value / 100000).toFixed(2) + 'L';
            }
            else if (value >= 10000000) {
                return (value / 10000000).toFixed(2) + 'CR';
            }
            return value;
        },
        formatTimeFromEpoch(timestamp) {
            const date = new Date(timestamp);
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const decimalTime = (hours + minutes / 60).toFixed(2);
            return `${decimalTime}h`;
        },
        formatTime(seconds) {
            if (seconds < 60) {
                return `${(seconds / 3600).toFixed(2)}h`;
            } else if (seconds < 3600) {
                const minutes = Math.floor(seconds / 60);
                return `${(minutes / 60).toFixed(2)}h`;
            } else {
                const hours = Math.floor(seconds / 3600);
                const minutes = Math.floor((seconds % 3600) / 60);
                const decimalTime = (hours + minutes / 60).toFixed(2);
                return `${decimalTime}h`;
            }
        },
    },
    mounted() {
        this.getSytemCpuCount("SYSTEM_CPU_COUNT");
        this.getProcessStartTime("PROCESS_START_TIME");
        this.getProcessUpTime("PROCESS_UP_TIME");
    }
};
</script>